import React from 'react';

import { TypographyTable } from '../index';

const headingValues = [
  {
    previewText: 'Aa',
    tokenName: 'font.heading.xxlarge',
    propValue: 'xxlarge',
    fontSize: '35px',
    lineHeight: '40px',
    fontWeight: 500,
  },
  {
    previewText: 'Aa',
    tokenName: 'font.heading.xlarge',
    propValue: 'xlarge',
    fontSize: '29px',
    lineHeight: '32px',
    fontWeight: 600,
  },
  {
    previewText: 'Aa',
    tokenName: 'font.heading.large',
    propValue: 'large',
    fontSize: '24px',
    lineHeight: '28px',
    fontWeight: 500,
  },
  {
    previewText: 'Aa',
    tokenName: 'font.heading.medium',
    propValue: 'medium',
    fontSize: '20px',
    lineHeight: '24px',
    fontWeight: 500,
  },
  {
    previewText: 'Aa',
    tokenName: 'font.heading.small',
    propValue: 'small',
    fontSize: '16px',
    lineHeight: '20px',
    fontWeight: 600,
  },
  {
    previewText: 'Aa',
    tokenName: 'font.heading.xsmall',
    propValue: 'xsmall',
    fontSize: '14px',
    lineHeight: '16px',
    fontWeight: 600,
  },
  {
    previewText: 'Aa',
    tokenName: 'font.heading.xxsmall',
    propValue: 'xxsmall',
    fontSize: '12px',
    lineHeight: '16px',
    fontWeight: 600,
  },
];

/**
 * __Typography heading table__
 */
export const TypographyHeadingTable = () => {
  return (
    <TypographyTable
      values={headingValues}
      testId="typography-heading-table"
    />
  );
};
